// expressed as pixel values
export var Sizes;
(function (Sizes) {
    Sizes[Sizes["xlarge"] = 64] = "xlarge";
    Sizes[Sizes["larger"] = 56] = "larger";
    Sizes[Sizes["large"] = 48] = "large";
    Sizes[Sizes["base"] = 40] = "base";
    Sizes[Sizes["small"] = 32] = "small";
    Sizes[Sizes["xsmall"] = 24] = "xsmall";
    Sizes[Sizes["xxsmall"] = 16] = "xxsmall";
})(Sizes || (Sizes = {}));
// expressed as multipliers of theme.shape.borderRadius (default 4)
export var Radius;
(function (Radius) {
    Radius[Radius["small"] = 1] = "small";
    Radius[Radius["base"] = 2] = "base";
    Radius[Radius["large"] = 4] = "large";
    Radius[Radius["round"] = 25] = "round";
})(Radius || (Radius = {}));
// expressed as pixel values
export var RadiusPixel;
(function (RadiusPixel) {
    RadiusPixel[RadiusPixel["small"] = 4] = "small";
    RadiusPixel[RadiusPixel["base"] = 8] = "base";
    RadiusPixel[RadiusPixel["large"] = 16] = "large";
    RadiusPixel[RadiusPixel["xlarge"] = 24] = "xlarge";
    RadiusPixel[RadiusPixel["round"] = 100] = "round";
})(RadiusPixel || (RadiusPixel = {}));
